import { h } from "preact";
import './timeline-styles.scss'
import Message from './Message'
import {useEffect, useState} from 'preact/hooks'
import {useDispatch, useSelector} from 'react-redux'
import { t } from '../../../_i18n'
import NewMessage from "./NewMessage";
import {fetchMessages, fetchStatus, markAsRead, rejectCompany} from "../../../_rx/fct/actions";
import {useParams} from "react-router";

export default function Timeline () {
  const [loading, setLoading] = useState(false)
  const [activeTab, setActiveTab] = useState('general');
  const messages = useSelector(state => state.fct.messages);
  const hasCompanySearchMessages = (messages?.company_search?.length ?? 0) > 0;
  const messagesToRender = activeTab === 'general' ? messages.general || [] : messages.company_search || [];
  const hasUnreadGeneral = messages.general?.some(m => !m.read);
  const hasUnreadCompany = messages.company_search?.some(m => !m.read);
  const canSend = activeTab === 'general' || (activeTab === 'company_search' && messages.search_is_open === true);
  const unreadCountCompany = messages.count_company_search;
  const unreadCountGeneral = messages.count_general;
  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    if (!hasCompanySearchMessages && activeTab === 'company_search') {
      setActiveTab('general');
    }
  }, [hasCompanySearchMessages, activeTab]);

    const markAsNotPending = (activeTab) => {
      const activeTabID = activeTab === 'general' ? 0 : 1;
      setLoading(true);
      markAsRead(id, activeTabID)
        .then(() => {
            setLoading(false);
            dispatch(fetchMessages(id))
        })
        .catch(() => setLoading(false))
    };


    return (
        <div className='fct-timeline'>
            <NewMessage activeTab={activeTab} onTabChange={setActiveTab} showCompanySearchTab={hasCompanySearchMessages}
                        hasUnreadGeneral={hasUnreadGeneral} hasUnreadCompany={hasUnreadCompany} canSend={canSend}
                        unreadCountCompany={unreadCountCompany} unreadCountGeneral={unreadCountGeneral}
            />
            { ((hasUnreadGeneral && activeTab === 'general') || (hasUnreadCompany && activeTab === 'company_search')) &&
                <div className="read-container">
                    <a className="mark-link" onClick={() => markAsNotPending(activeTab)}> {t('Marcar todos como leídos')} </a>
                </div>
            }
            <div className='fct-messages-wrapper'>
                {messagesToRender.map(({id, type, header, message_direction, read, content, send_at, attached_docs}) =>
                    <Message id={id}
                             type={type}
                             title={
                                 type === 'event'
                                     ? header
                                     : message_direction === 'received'
                                         ? t('Departamento de practicas')
                                         : t('Yo')
                             }
                             message_direction={message_direction}
                             read={read}
                             date={send_at}
                             body={type === 'message' && content}
                             attached={attached_docs}
                    />)
                }
            </div>
        </div>
    )
}
